import Vue from 'vue'
import config from '@/pages.common'
import Meta from 'vue-meta'

import {firstSearch} from '@/components/Monitoring/Monitoring.common';
setTimeout(() => firstSearch({state: 1}), 0);

Vue.use(Meta);

new Vue({
  ...config,
  components: { 'MonitoringOpen': () => import ('@/components/MonitoringOpen') },
  render: h => h('MonitoringOpen')
}).$mount('#MonitoringOpen');
